var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.128 5.74667C9.33798 5.74667 8.11548 4.84833 6.82798 4.88C5.12798 4.9025 3.56965 5.86583 2.69381 7.39167C0.929646 10.4542 2.23881 14.9775 3.95965 17.4667C4.80381 18.6783 5.79965 20.0417 7.11965 19.9992C8.38631 19.945 8.86131 19.1767 10.3988 19.1767C11.9246 19.1767 12.3571 19.9992 13.6988 19.9667C15.063 19.945 15.9288 18.7333 16.7621 17.51C17.7255 16.1033 18.1255 14.7392 18.1471 14.6642C18.1146 14.6533 15.4955 13.6467 15.4638 10.6167C15.4421 8.08333 17.5305 6.87167 17.628 6.8175C16.4371 5.07583 14.6088 4.88083 13.9696 4.8375C12.303 4.7075 10.9071 5.74667 10.128 5.74667ZM12.943 3.19167C13.6455 2.34833 14.1096 1.16917 13.9805 0C12.9746 0.0433333 11.7621 0.670833 11.0371 1.515C10.3871 2.26167 9.82548 3.46333 9.97631 4.61C11.0913 4.69667 12.2388 4.03667 12.9421 3.1925",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.0a52cc182563ce6d017a98d9c28cb443.svg";
export { ForwardRef as ReactComponent };